import type { RouteRecordRaw } from 'vue-router'

/**
 * The checkout journey (frontend phase-09 §2.1).
 *
 * **Each step is its own route**, so refresh, back and a bookmark all work, and so the return
 * from the gateway — which is a fresh page load from another origin — lands somewhere real.
 *
 * The first two steps are addressed by **reservation**; the last two by **payment reference**,
 * because that is the only identifier the visitor comes back from Credo with.
 *
 * Marketplace layout, no dashboard chrome, no authentication: a stranger completes this whole
 * journey without an account.
 */
const checkout = { layout: 'marketplace' as const, public: true }

export const checkoutRoutes: RouteRecordRaw[] = [
  {
    path: '/checkout/:reservationId/details',
    name: 'checkout-details',
    component: () => import('./pages/CheckoutDetailsPage.vue'),
    meta: checkout,
  },
  {
    path: '/checkout/:reservationId/review',
    name: 'checkout-review',
    component: () => import('./pages/CheckoutReviewPage.vue'),
    meta: checkout,
  },
  {
    path: '/checkout/:reference/return',
    name: 'checkout-return',
    component: () => import('./pages/CheckoutReturnPage.vue'),
    meta: checkout,
  },
  {
    path: '/checkout/:reference/complete',
    name: 'checkout-complete',
    component: () => import('./pages/CheckoutCompletePage.vue'),
    meta: checkout,
  },
]
